import React, { useMemo, useState } from "react";
import { Consult } from "../../components/Consult";

import dayjs from "dayjs";

import { Button } from "antd";
import { request } from "../../functions/request";
import { Content } from "antd/es/layout/layout";
import { AiFillEdit, AiFillEye } from "react-icons/ai";
import { Link,  useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaSave } from "react-icons/fa";


export default function ConsultAnaliseInativas() {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [data, setData] = useState([]);
  const [modalContent, setModalContent] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const columns = useMemo(
    () => [
      {
        accessorKey: "com_numero",
        header: "ID",
        size: 40,
      },
      {
        accessorKey: "com_titulo",
        header: "Título",
        size: 100,
      },
      {
        accessorKey: "com_data",
        header: "Data",
        size: 30,
      },
      {
        accessorKey: "com_secao",
        header: "Seção",
        size: 60,
        filterVariant: "multi-select",
      },
    ],
    []
  );

  const transformSectionComent = (section) => {
    switch (section) {
      case 1:
        return "Boi";
      case 3:
        return "Frango";
      case 4:
        return "Leite";
      case 5:
        return "Suínos";
      case 10:
        return "Trigo";
      case 11:
        return "Algodão";
      case 21:
        return "Soja";
      case 22:
        return "Milho";
      case 23:
        return "Café";
      case 24:
        return "Açucar";
      default:
        return "";
    }
  };
    function refreshPage(path = 0, timeout = 1000) {
    setTimeout(() => {
      navigate(path, { replace: true });
    }, timeout);
  }
    const approvalItem = (com_numero) => {
      const currentPathWithQuery = `/comentario/updateComentariosAtivo/${com_numero}`;
        request(currentPathWithQuery, {
          method: "PUT",
        }).finally(() => {
          toast.success("Analise aprovada com sucesso!");
          refreshPage("/comentario-inativas");
          fetchData();
        });
    };
  const fetchData = async () => {
    try {
      setHasError(false);
      setIsLoading(true);
      await request(`/comentario/getcomentariosapproval`, {
        method: "GET",
      })
        .then((response) => {
          const arr = Array.isArray(response) ? response : response?.[0];
          if (!Array.isArray(arr)) {
            setData([]);
            setHasError(true);
            return;
          }
          const formattedData = arr.map((res) => {
            res.com_data = dayjs(res?.com_data).format("DD/MM/YYYY HH:mm");
            res.com_secao = transformSectionComent(res?.com_secao);
            return res;
          });
          if (formattedData.length <= 0) {
            setData([]);
            setHasError(true);
          } else {
            setData(formattedData);
          }
        })
        .finally(() => {
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setData([]);
          setIsLoading(false);
          setHasError(true);
        });
    } catch (error) {
      console.error("Erro na requisição:", error);
      setData([]);
      setIsLoading(false);
      setHasError(true);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <Content>
      <Consult.Table
        data={data}
        columns={columns}
        isLoading={isLoading}
        hasError={hasError}
        style={{width: "800px" }}
        initialState={{
          showColumnFilters: true,
          pagination: { pageIndex: 0, pageSize: 100 },
        }}
        renderRowActions={({ row }) => (
          <Content
            style={{
              display: "flex",
              gap: "5px",
              flexWrap: "wrap",
            }}
          >
            <Button
              onClick={() => {
                setModalContent(row.original);
                setIsModalOpen(true);
              }}
              icon={<AiFillEye />}
            >
              Visualizar
            </Button>
            <Link
              to={`/editor-analise/${row.original.com_numero}`}
              //target="_blank"
            >
              <Button icon={<AiFillEdit />}>Editar</Button>
            </Link>
             <Button
             type="primary"
                icon={<FaSave />}
                onClick={() => {approvalItem(row.original.com_numero) }}
                >
                Aprovar
               </Button>
          </Content>
        )}
      />
      <Consult.Modal
        title={modalContent?.com_titulo}
        date={modalContent?.com_data}
        text={modalContent?.com_texto}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
      />
    </Content>
  );
}
